export const isRunningInIframe = () => {
  return !(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope);
};
//# sourceMappingURL=isRunningInIframe.js.map